export default class DemographicTenants {
    public gender: string;
    public age: number;
    public socialClubs: string[];
    public educations: string[];

    constructor(
        gender: string = null,
        age: number = null,
        socialClubs: string[] = [],
        educations: string[] = [],
    ) {
        this.gender      = gender;
        this.age         = age;
        this.socialClubs = socialClubs;
        this.educations  = educations;
    }
}
